import React, { createContext, useContext, useState, useEffect } from 'react';

const TextSizeContext = createContext();

const SIZES = {
  small:  { label: 'Small',  class: 'text-size-sm',  scale: '87.5%' },
  medium: { label: 'Medium', class: 'text-size-md',  scale: '100%' },
  large:  { label: 'Large',  class: 'text-size-lg',  scale: '112.5%' },
  xl:     { label: 'Extra Large', class: 'text-size-xl', scale: '125%' },
};

export const TextSizeProvider = ({ children }) => {
  const [size, setSize] = useState(() => localStorage.getItem('ci-text-size') || 'medium');

  useEffect(() => {
    const root = document.documentElement;
    root.style.fontSize = SIZES[size]?.scale || '100%';
    localStorage.setItem('ci-text-size', size);
  }, [size]);

  const changeSize = (newSize) => {
    if (SIZES[newSize]) setSize(newSize);
  };

  return (
    <TextSizeContext.Provider value={{ size, changeSize, sizes: SIZES }}>
      {children}
    </TextSizeContext.Provider>
  );
};

export const useTextSize = () => useContext(TextSizeContext);
